import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import WidgetCard from "./WidgetCard";
import { ICTRFormattedData, ICtrTrendOverTimeProps } from "@ts/common-types";
import { COLORS } from "@ts/constants";
import { Col, Row } from "antd";

const CtrTrendOverTime: React.FC<ICtrTrendOverTimeProps> = ({ widgetData, additionalTitleComponent, filterPillsComponent }) => {

    const chartOptions = {
        chart: {
            type: "column",
        },
        title: {
            text: "",
        },
        credits: {
            enabled: false,
        },
        colors: COLORS,
        xAxis: {
            categories: widgetData?.categories,
            title: {
                text: "Weeks",
            },
        },
        yAxis: [
            {
                title: {
                    text: "ROAS, CTR, Conversion Rate",
                },
            },
            {
                title: {
                    text: "Impressions",
                },
                opposite: true,
            },
        ],
        legend: {
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
        },
        series: widgetData?.series,
    };

    return (
        <WidgetCard className="my-4">
            <Row className="fs-5 mb-5 w-100" justify="space-between">
                <Col span={16}>
                    <h5>CTR Trend Over Time</h5>
                </Col>
                {additionalTitleComponent && (
                    <Col span={1}>{additionalTitleComponent()}</Col>
                )}
            </Row>
            {filterPillsComponent && (
                <Row>
                    <Col span={24}>{filterPillsComponent()}</Col>
                </Row>
            )}
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </WidgetCard>
    );
};

export default CtrTrendOverTime;